import React from 'react';
import { useNavigate } from 'react-router-dom';
import eImg from '../../../img/coves1.jpeg';
import jImg from '../../../img/coves2.jpeg';
import lImg from '../../../img/coves3.jpeg';

const ProductsCoves = () => {
  const navigate = useNavigate();

  const covesProducts = [
    {
      moldingNumber: "C001",
      description: "Elegant cove molding with a smooth curve, ideal for classic interiors.",
      images: [eImg]
    },
    {
      moldingNumber: "C002",
      description: "Simple and modern cove molding, perfect for contemporary designs.",
      images: [jImg]
    },
    {
      moldingNumber: "C003",
      description: "Decorative cove molding with intricate details for unique spaces.",
      images: [lImg]
    },
  ];

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-8 font-montserrat">
        Cove Molding Collection
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {covesProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.moldingNumber}
          >
            <div className="w-full h-48">
              {product.images.map((image, index) => (
                <img
                  src={image}
                  alt={`Cove molding ${product.moldingNumber}`}
                  className="w-full h-full object-cover"
                  key={index}
                />
              ))}
            </div>

            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Cove Molding {product.moldingNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">Need More Information?</h5>
            <p className="text-emerald-100 mb-4">
              Interested in our cove moldings? Want to discuss custom designs or get a quote? 
              Our team is ready to assist you in finding the perfect molding for your project.
            </p>
            <p className="text-emerald-100">
              To view the complete list of products, please register to obtain your access token (key).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contact us →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCoves;



